export class FilterSettings {
    public static default(): FilterSettings {
        return new FilterSettings();
    }

    protected _industryId: number | string | undefined;
    protected _searchTerm: string | undefined;
    protected _sectorId: number | string | undefined;
    protected _branchId: string | undefined;

    constructor(
        industryId?: number | string | undefined,
        sectorId?: number | string | undefined,
        branchId?: string | undefined,
        searchTerm?: string | undefined
    ) {
        this._searchTerm = searchTerm;
        this._industryId = industryId;
        this._branchId = branchId;
        this._sectorId = sectorId;
    }

    get industryId(): number | string | undefined {
        return this._industryId;
    }

    get sectorId(): number | string | undefined {
        return this._sectorId;
    }

    get branchId(): string | undefined {
        return this._branchId;
    }

    get searchTerm(): string | undefined {
        return this._searchTerm;
    }

    public withIndustryId(industryId: string | number | undefined): FilterSettings {
        const clone = this.clone();
        clone._industryId = industryId;

        return clone;
    }

    public withSectorId(sectorId: string | number | undefined): FilterSettings {
        const clone = this.clone();
        clone._sectorId = sectorId;

        return clone;
    }

    public withBranchId(branchId: string | undefined): FilterSettings {
        const clone = this.clone();
        clone._branchId = branchId;

        return clone;
    }

    public withSearchTerm(searchTerm: string | undefined): FilterSettings {
        const clone = this.clone();
        clone._searchTerm = searchTerm;

        return clone;
    }

    public clone(): FilterSettings {
        return new FilterSettings(
            this._industryId,
            this._sectorId,
            this._branchId,
            this._searchTerm,
        );
    }
}

export type OnFilterSettingsChange = (filterSettings: FilterSettings) => void;
